"use client"

import React, { useEffect, useRef } from "react"
import { Animated, ImageBackground } from "react-native"
import { styled } from "nativewind"

type Props = {
  backgroundUrl: string
}

const Background = styled(Animated.createAnimatedComponent(ImageBackground))

const AnimatedBackground = ({ backgroundUrl }: Props) => {
  const opacity = useRef(new Animated.Value(0)).current

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 1000,
      useNativeDriver: true,
    }).start()
  }, [])
  return (
    <Background
      source={{ uri: backgroundUrl }}
      className="absolute bottom-0 left-0 right-0 top-0 z-[-1] bg-cover bg-center opacity-0"
      resizeMode="cover"
      style={{ opacity }}
    />
  )
}

export default AnimatedBackground
